import * as React from "react";
import Menu from "../Pages/Admin/Menu";

import "./Content.scss";

class Content extends React.Component{

    constructor(props) {
        super(props);
        document.title = this.props.title ?? 'Default';

        setTimeout(()=>{
            try {
                document
                    .getElementsByClassName('content-page')
                    .item(0)
                    .children
                    .item(0)
                    .style
                    .opacity = 1;
            }
            catch (E){
            }
        }, 200);

    }

    render() {
        return (
            <>
                <Menu current = {window.location.pathname}/>
                <div className="container-fluid pt-4 content-page">
                    <div className="card shadow border-0 content-page-card">
                        <div className="card-body">
                            { this.props.children }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Content;